import { ProduitProposePMNDTO } from "@/modules/pmn/pmn-administration/models/PMNModele"

// Si changement sur l'enum, ne pas oublier de modifier le fichier .cs : Biobank.Domaine/Enums/TypeInput.cs
export enum TypeInput {
    Texte,
    Nombre,
    CodePostal,
    Email,
    Date,
    ListeProposition,
    Telephone
}

export const ListeTypeInput = [
    {
        text: 'Texte',
        value: TypeInput.Texte
    },
    {
        text: 'Nombre',
        value: TypeInput.Nombre
    },
    {
        text: 'CodePostal',
        value: TypeInput.CodePostal
    },
    {
        text: 'Email',
        value: TypeInput.Email
    },
    {
        text: 'Date',
        value: TypeInput.Date
    },
    {
        text: 'Case à cocher',
        value: TypeInput.ListeProposition
    },
    {
        text: 'Telephone',
        value: TypeInput.Telephone
    }
]

export enum TypePMNModele_Fichier
{
    Dentaire,
    DomTom,
    GSM,
    Kit,
    MaxilloLPPR,
    Ortho
}

export class PMNModele {
    id = 0
    label = ''
    dateCreation = ''
    inputs: PMNModele_Input[] = []
    produitsProposes: ProduitProposePMNDTO[] = []
    version: number | null = null
    type: TypePMNModele_Fichier = TypePMNModele_Fichier.Dentaire
}

export class PMNModele_Input {
    id = 0
    label = ''
    typeInput: TypeInput = TypeInput.Texte
    dateMinimaleAujourdhui: boolean | null = null
    propositions: PMNModele_Input_Proposition[] = []
}

export class PMNModele_Input_Proposition {
    id = 0
    label = ''
}
